// extracted by mini-css-extract-plugin
export default {"desktop":"Desktop_desktop__n0FaH","floatingButton":"Desktop_floatingButton__jY-x3"};